import apiClient from "../../client/apiClient"

const SYSTEMS_ENDPOINT = {
  SYSTEMS:"/systems"
  }

export type BoardSystem = {
  _id: string
  name: string
  code: string
  style: "local" | "cambridge"
  description: string
  status: "active" | "inactive"
}

const getAllSystems = async () => {
    const response = await apiClient({
      url:SYSTEMS_ENDPOINT.SYSTEMS,
      method: "GET",
    })

    return response.data
  }

// Board Systems config page: name/description/status only. `code` and
// `style` drive real grading logic elsewhere and are deliberately never
// sent from here -- code's enum doesn't cover every live value (e.g. TECH/
// PNMC), and PUT /systems/:id runs full schema validators.
const updateSystem = async (
  id: string,
  data: { name?: string; description?: string; status?: "active" | "inactive" }
) => {
  const response = await apiClient({
    url: `${SYSTEMS_ENDPOINT.SYSTEMS}/${id}`,
    method: "PUT",
    data,
  })
  return response.data
}

  export { getAllSystems, updateSystem }
  
  